import { Divider } from '@material-ui/core'
import AccordionCard from 'projectSections/sections/info/AccordionCard'
import React, { useCallback } from 'react'
import { useTranslate } from 'react-admin'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'
import { useComponentTypeByRoute } from '../../../pages/ordering/Routes'
import { PHASE_FILTER_KEY } from '../phaseType/PhaseTypeFilterNodeFactory'
import getRatingOverrideLabel from '../rating/getRatingOverrideLabel'
import { RATING_FILTER_NODE_KEY } from '../rating/RatingFilterNodeFactory'
import { addFilterToLastRecentUsedList, removeFilterFromLastRecentUsedList } from '../utils/lruFilterCacheStore'
type AccordionOptions = {
  defaultExpanded?: boolean
  showDivider?: boolean
  recordLru?: boolean
}
const useStyles = makeOpenSolarStyles(
  (theme) => ({
    root: {
      background: 'none',
      boxShadow: 'none !important',
      border: 'none !important',
      borderRadius: '0 !important',
      margin: '0 !important',

      '& .OSUI-Collapse-root': {
        borderTop: `none !important`,
      },
    },
    details: {
      padding: '10px 0 !important',
    },
    summaryRoot: {
      minHeight: 'unset !important',
      height: '42px !important',
    },
    divider: {
      margin: '0 5px',
      background: 'rgba(236, 236, 237, 0.9)',
    },
  }),
  { name: 'AccordionFilter' }
)

const createAccordionRenderer = <T,>({
  filterKey,
  filterLabel,
  BasicRenderer,
  options,
}: {
  filterLabel?: string
  BasicRenderer: React.FC<T>
  options?: AccordionOptions
  filterKey: string
}) => {
  return (props) => {
    const classes = useStyles()
    const translate = useTranslate()
    const onValueChanged = useCallback(
      (expanded: boolean) => {
        if (options?.recordLru) {
          if (expanded) {
            addFilterToLastRecentUsedList(filterKey)
          } else {
            removeFilterFromLastRecentUsedList(filterKey)
          }
        }
      },
      [options?.recordLru]
    )

    const componentType = useComponentTypeByRoute()

    // Special case for rating filter label
    let label = filterKey === RATING_FILTER_NODE_KEY ? getRatingOverrideLabel(componentType) : filterLabel

    // Special case for meter phase label
    const isMeterPhaseLabel = componentType && componentType === 'other' && filterKey === PHASE_FILTER_KEY
    if (isMeterPhaseLabel) {
      label = 'Meter Phase'
    }

    return (
      <>
        <AccordionCard
          name={props.id || props.label}
          elevation={0}
          onChange={onValueChanged}
          title={translate(label || props.label)}
          disabled={props.disabled}
          defaultExpanded={!!options?.defaultExpanded}
          className={classes.root}
          detailsClassName={classes.details}
          classes={{ summaryRoot: classes.summaryRoot }}
          disableGutters
          removeCollapseBorder
          preventPacking
        >
          <BasicRenderer {...props} />
        </AccordionCard>
        {!!options?.showDivider && <Divider className={classes.divider} />}
      </>
    )
  }
}

export default createAccordionRenderer
